export default __webpack_public_path__ + "assets/images/73460f9fb61b8371eed08f87770cb0fc.png";